import { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
export function getIconButtonSize(size) {
    switch (size) {
        case 'xs':
            return css `
        width: ${pxToRem(24)};
        height: ${pxToRem(24)};
        [data-icon='falcon'] {
          width: ${pxToRem(12)};
          height: ${pxToRem(12)};
        }
      `;
        case 'small':
            return css `
        width: ${pxToRem(32)};
        height: ${pxToRem(32)};
      `;
        case 'large':
            return css `
        width: ${pxToRem(48)};
        height: ${pxToRem(48)};
      `;
        case 'medium':
        default:
            return css `
        width: ${pxToRem(40)};
        height: ${pxToRem(40)};
      `;
    }
}
